export class AppConstants {
    public static readonly APP_NAME = 'Folio';
    public static readonly APP_ID = 9;

    public static readonly URL_DOMAIN_PROD = 'https://playclay.io/';
    public static readonly URL_DOMAIN_DEV = 'http://dev.focalcxm.com/';
    public static readonly URL_DOMAIN_STAGE = 'http://dev.focalcxm.com/';

    public static readonly URL_SUB_PATH = 'playclay/rest/';

    public static readonly URL_LOGIN_AUTHENTICATE = 'login/authenticate';
    public static readonly URL_LOGIN_FETCH_USER_DETAILS = 'login';

    public static readonly URL_AWS_PROD = 'https://api.batonservice.com/prod/';
    public static readonly URL_AWS_STAGE = 'https://uotegme9qk.execute-api.us-east-1.amazonaws.com/stage/';
    public static readonly URL_AWS_DEV = 'https://www.devfocal.de/dev/';
    public static readonly URL_AWS_VALIDATION_SERVICE_ENDPOINT = 'baton/auth/validatetoken';
    public static readonly URL_AWS_BATON_CHANGE_PASSWORD = 'baton/auth/fcxm/resetpassword';

    // Get Features List START
    public static readonly URL_BATON_GET_FEATURES_STAGE = AppConstants.URL_AWS_STAGE + 'baton/core/features';
    public static readonly URL_BATON_GET_FEATURES_DEV = AppConstants.URL_AWS_DEV + 'baton/core/features';
    public static readonly URL_BATON_GET_FEATURES_PROD = AppConstants.URL_AWS_PROD + 'baton/core/features';

    // Get Features List START
    public static readonly LAMBDA_NAME_BATON_GET_FEATURES_STAGE = 'GetCustomerFeaturesV2_dev';
    public static readonly LAMBDA_NAME_BATON_GET_FEATURES_DEV = 'GetCustomerFeaturesV2_dev';
    public static readonly LAMBDA_NAME_BATON_GET_FEATURES_PROD = 'GetCustomerFeatures:1';

    // quicksight dashboard
    public static readonly AWS_ACCOUNTID_DEV = '463994100217';
    public static readonly LAMBDA_NAME_FOLIO_GET_QSDASHBOARDURL_DEV =
        'GetDashboardURL-GetDashboardURL-i0lRSGWs7bb9'; // Change the name from aws stack
    public static readonly QSUSERACCESS_ROLEARN_DEV = 'arn:aws:iam::463994100217:role/Folio_Quicksight_UserAccess';
    public static readonly QSDASHBOARD_ID_DEV = '11285f3d-e85f-43c4-a4dd-9d736af0b3b0';
    // PROD
    public static readonly AWS_ACCOUNTID_PROD = '';
    public static readonly LAMBDA_NAME_FOLIO_GET_QSDASHBOARDURL_PROD =
        'GetQSDashboardStack-GetDashboardURL-RPBcoejl81Z9:1'; // Change the name from aws stack
    public static readonly QSUSERACCESS_ROLEARN_PROD = 'arn:aws:lambda:us-west-2:525822000441';
    public static readonly QSDASHBOARD_ID_PROD = '';
    // quicksight dashboard END

    // arn:aws:lambda:us-west-2:525822000441:function:GetQSDashboardStack-GetDashboardURL-RPBcoejl81Z9:1
    public static readonly URL_SP_ASSESSMENTS_DEV =
        'http://batonstage-env.pf58udzph9.us-east-1.elasticbeanstalk.com/storypulse/login/baton_token_access.html?';
    public static readonly URL_SP_ASSESSMENTS_STAGE =
        'https://storypulsedev.focalcxm.com/admin-console/#/pages/login/external-login?';
    public static readonly URL_SP_ASSESSMENTS_PROD = 'https://storypulse.focalcxm.com/admin-console/#/pages/login/external-login?';

    public static readonly URL_PLAYCLAY_PROD = 'https://playclayapi.focalcxm.com/prod/playclay/';
    public static readonly URL_PLAYCLAY_QA = '';
    public static readonly URL_PLAYCLAY_DEV = '';

    public static readonly URL_PROD_BATON_REDIRECTION = 'https://baton.focalcxm.com/#/login/9';
    public static readonly URL_STAGE_BATON_REDIRECTION = 'http://dev.focalcxm.com/baton-client-v2/login/9';
    public static readonly URL_DEV_BATON_REDIRECTION = 'http://dev.focalcxm.com/baton-client-v2/login/9';

     //Activities
     public static readonly URL_PROD_PLAYCLAY_ACTIVITY = AppConstants.URL_PLAYCLAY_PROD + "activity";
    
     public static readonly URL_PROD_BATON_USERS = 'https://mn3a34h9z9.execute-api.us-west-2.amazonaws.com/prod/baton/core/users?';
    public static readonly URL_PROD_BATON_CONFIG_REDIRECTION = 'https://baton.focalcxm.com/#/validate-token?appId=';
    public static readonly URL_STAGE_BATON_CONFIG_REDIRECTION = 'https://dev.focalcxm.com/baton-client-v2/#/validate-token?appId=';
    public static readonly URL_DEV_BATON_CONFIG_REDIRECTION = 'https://dev.focalcxm.com/baton-client-v2/#/validate-token?appId=';


    public static readonly URL_PROD_BATON_DASHBOARD_REDIRECTION = 'https://baton.focalcxm.com/#/dashboard';
    public static readonly URL_STAGE_BATON_DASHBOARD_REDIRECTION = 'http://dev.focalcxm.com/baton-client-v2/#/dashboard';
    public static readonly URL_DEV_BATON_DASHBOARD_REDIRECTION = 'http://dev.focalcxm.com/baton-client-v2/#/dashboard';

    // ::: Params :::
    public static readonly PARAM_LOGIN_USERNAME = 'username';
    public static readonly PARAM_LOGIN_PASSWORD = 'password';
    public static readonly PARAM_LABEL_COMPANY_ID = 'companyId';
    public static readonly PARAM_LABEL_MONGO_COLLECTION_NAME = 'collectionName';
    public static readonly PARAM_COMPANY_LEVEL_VISIBILITY = 'companyLevelVisibility';
    public static readonly PARAM_REST_SERVICE_PAGE = 'page';
    public static readonly PARAM_REST_SERVICE_LIMIT = 'limit';
    public static readonly PARAM_APP_ID = 'AppId';
    public static readonly PARAM_ENVIRONMENT = 'environment';
    public static readonly PARAM_CUSTOMER_ID = 'CustomerId';

    public static readonly PARAM_MONGO_UNIQUE_ID = 'uniqueId';

    public static readonly PARAM_LABEL_SP_ASSESSMENTS_TOKEN = 'cognitoToken';
    public static readonly PARAM_LABEL_SP_ASSESSMENTS_APP_NAME = 'appName';
    public static readonly PARAM_LABEL_SP_ASSESSMENTS_ORG_ID = 'orgId';

    // baton
    public static readonly PARAM_BATON_CHANGE_PASS_USERNAME = 'userName';
    public static readonly PARAM_BATON_CHANGE_PASS_PASSWORD = 'password';
    public static readonly PARAM_BATON_CHANGE_PASS_NEW_PASSWORD = 'newPassword';

    // ::: LOCAL STORAGE :::
    public static readonly PARAM_LOCAL_STORAGE_AUTH_TOKEN = '__auth_token__';
    public static readonly PARAM_LOCAL_STORAGE_AUTH_LOGIN_INFO = '__login_info__';
    public static readonly PARAM_LOCAL_STORAGE_WORKSHOP_DATA = '__workshop_data__';
    public static readonly PARAM_LOCAL_STORAGE_NAV_ITEMS = '__nav_items__';
    public static readonly PARAM_LOCAL_STORAGE_DEFAULT_ROUTE = '__default_route__';

    // ::: MODULE NAMES :::
    public static readonly PARAM_MODULE_NAME_TEAMS = 'Teams';
    public static readonly PARAM_MODULE_NAME_PROJECTS = 'Projects';
    public static readonly PARAM_MODULE_NAME_ASSESSMENTS = 'Assessments';
    public static readonly PARAM_MODULE_NAME_WORKSHOP = 'Workshop';
    public static readonly PARAM_MODULE_NAME_REPORTS = 'Reports';

    /** Route values */
    public static readonly PARAM_ROUTE_VALUE_TEAMS = 'teams';
    public static readonly PARAM_ROUTE_VALUE_ADD_TEAM = 'add-team';
    public static readonly PARAM_ROUTE_VALUE_PROJECTS = 'projects';
    public static readonly PARAM_ROUTE_VALUE_ADD_PROJECTS = 'projects-details';
    public static readonly PARAM_ROUTE_VALUE_ASSESSMENTS = 'assessments';
    public static readonly PARAM_ROUTE_VALUE_STORIES = 'stories';
    public static readonly PARAM_ROUTE_VALUE_REPORTS = 'reports';
    public static readonly PARAM_ROUTE_VALUE_METRICS = 'metrics';
    public static readonly PARAM_ROUTE_VALUE_WORKSHOPS = 'workshop';

    public static readonly PARAM_ROUTE_VALUE_LOGIN = '/login';
    public static readonly PARAM_ROUTE_VALUE_RESET_PASSWORD = '/reset-password';
    public static readonly PARAM_ROUTE_VALUE_HOME = '/home';

    // appsync flow usages...
    public static readonly URL_PROD_APPSYNC_GRAPHQL_ENDPOINT = 'https://eszr3qicrbepheqtb6sffmqfva.appsync-api.us-west-2.amazonaws.com/graphql';
    public static readonly URL_STAGE_APPSYNC_GRAPHQL_ENDPOINT = 'https://fjuyfymduzcv3owmbmcip3chgq.appsync-api.us-east-1.amazonaws.com/graphql';
    public static readonly URL_DEV_APPSYNC_GRAPHQL_ENDPOINT = AppConstants.URL_STAGE_APPSYNC_GRAPHQL_ENDPOINT;

    public static readonly PARAM_PROD_APPSYNC_REGION = 'us-west-2';
    public static readonly PARAM_STAGE_APPSYNC_REGION = 'us-east-1';
    public static readonly PARAM_DEV_APPSYNC_REGION = AppConstants.PARAM_STAGE_APPSYNC_REGION;

    // public static readonly PARAM_PROD_APPSYNC_API_KEY = 'da2-uponkeqglfdprlzt7kcg5nmqqy';
    public static readonly PARAM_PROD_APPSYNC_API_KEY = 'da2-xtnotqebwvdaffjvgdcvhgnwmm';

    // public static readonly PARAM_STAGE_APPSYNC_API_KEY = 'da2-33eb4iohr5ewrjz7twktoivlky';
    // public static readonly PARAM_STAGE_APPSYNC_API_KEY = 'da2-fsxitt3f2rhdze6tkeobsigfmm';
    public static readonly PARAM_STAGE_APPSYNC_API_KEY = 'da2-xponh5q7tnfetc5dnokitbnhde';



    public static readonly PARAM_DEV_APPSYNC_API_KEY = AppConstants.PARAM_STAGE_APPSYNC_API_KEY;

    public static readonly PARAM_PROD_APPSYNC_USERPOOL_ID = 'us-west-2_7JGfP2Q4M';
    public static readonly PARAM_STAGE_APPSYNC_USERPOOL_ID = 'us-east-1_WzuPZDmhf';
    public static readonly PARAM_DEV_APPSYNC_USERPOOL_ID = AppConstants.PARAM_STAGE_APPSYNC_USERPOOL_ID;

    public static readonly PARAM_PROD_APPSYNC_USERPOOL_WEBCLIENT_ID = '6gbeh45sag48k2prqv14o6013m';
    public static readonly PARAM_STAGE_APPSYNC_USERPOOL_WEBCLIENT_ID = 'bumsvtajcvhkvl4vqr3z5ingke';
    public static readonly PARAM_DEV_APPSYNC_USERPOOL_WEBCLIENT_ID = AppConstants.PARAM_STAGE_APPSYNC_USERPOOL_WEBCLIENT_ID;

    // AWS S3 .....
    public static readonly PARAM_DEV_S3_BUCKET_FOLIO = 'https://folio1.s3.amazonaws.com/';
    public static readonly PARAM_PROD_S3_BUCKET_FOLIO = 'https://folio1.s3.amazonaws.com/';
    public static readonly PARAM_STAGE_S3_BUCKET_FOLIO = 'https://folio1.s3.amazonaws.com/';

    // AWS DETAILS
    public static readonly AWS_REGION_STAGE = 'us-east-1';
    public static readonly AWS_REGION_DEV = 'us-east-1';
    public static readonly AWS_REGION_PROD = 'us-west-2';

    public static readonly AWS_IDENTITYPOOL_ID_STAGE = 'us-east-1:2502f29e-a42c-4bbe-a9dd-64ddaa9aa34e';
    public static readonly AWS_IDENTITYPOOL_ID_DEV = 'us-east-1:2502f29e-a42c-4bbe-a9dd-64ddaa9aa34e';
    public static readonly AWS_IDENTITYPOOL_ID_PROD = 'us-west-2:57bcc73a-1232-4452-bda4-beb2a2a27e3b';

    // GoJS Tree Params START
    public static readonly PARAM_GO_JS_UNLOCK = '2bf843ebb66758c511d35a25403f7efb0ff12d35ce804df3590717f0ec0a611c23cce17155d28d94c0e849f44a75c08e8a903e29954e056cee30d78c13b182f1b46573b41301458ef70b23c2cead2da2fb7879f397bc65b2dc2ddcf4ebfa939d4ef8f0d548c211bd367b01';
    public static readonly PARAM_GO_JS_FOCAL_PROBLEM_COLOR = '#023359';
    public static readonly PARAM_GO_JS_EFFECT_COLOR = '#C60031';
    public static readonly PARAM_GO_JS_PROXIMAL_EFFECT_COLOR = '#C60031';
    public static readonly PARAM_GO_JS_CAUSE_COLOR = '#26ae63';
    public static readonly PARAM_GO_JS_PROXIMAL_CAUSE_COLOR = '#26ae63';

    public static readonly PARAM_GO_JS_DIRECTION_TOP = 'right';
    public static readonly PARAM_GO_JS_DIRECTION_BOTTOM = 'left';

    public static readonly PARAM_GO_JS_NODE_TYPE_EFFECT = 'Effect';
    public static readonly PARAM_GO_JS_NODE_TYPE_CAUSE = 'Cause';
    public static readonly PARAM_GO_JS_NODE_TYPE_SIBLING = 'Sibling';

    public static readonly PARAM_GO_JS_DIV_ID_PROBLEM_TREE = 'problemTree';
    public static readonly PARAM_GO_JS_DIV_ID_OBJECTIVE_TREE = 'objectiveTree';
    public static readonly PARAM_GO_JS_TREE_HOVER_DELAY = '800';

    // GoJS Tree Params END
    public static readonly PARAM_CHAR_LIMIT_SHORT_TEXT = 40;
    public static readonly LS_SHOW_HELP_SECTION_HOME = 'show_help_section_in_home';
    static readonly BACKEND_TYPE_BATON = 'Baton';
    static readonly BACKEND_TYPE_PLAYCLAY = 'PlayClay';

}


export class LabelConstants {
    public static readonly LABEL_APP_NAME = 'Folio';

    // Auth/Login related ....
    public static readonly LABEL_HEADING_CHANGE_PASSWORD = 'Reset Password';
    public static readonly LABEL_BUTTON_CHANGE_PASSWORD = 'Reset';
    public static readonly LABEL_SUCCESS = 'Success';
    public static readonly LABEL_PASSWORD_CHANGED = 'Password changed successfully';

    // Navigation Data related ....
    public static readonly LABEL_NAV_LIST_ITEM_TEAMS = 'Teams';
    public static readonly LABEL_NAV_LIST_ITEM_PROJECTS = 'Projects';
    public static readonly LABEL_NAV_LIST_ITEM_STORIES = 'Enterprise Stories';
    public static readonly LABEL_NAV_LIST_ITEM_REPORTS = 'Reports';
    public static readonly LABEL_NAV_LIST_ITEM_ASSESSMENTS = 'Assessments';
    public static readonly LABEL_NAV_LIST_ITEM_WORKSHOPS = 'Workshops';
    // Navigation Data related END ....

    // Home Page Related ....
    // NONE
    // Home Page Related END....

    // TEAMS Related ....
    public static readonly LABEL_TEAMS_HEADER_TITLE = 'Teams';
    public static readonly LABEL_TEAMS_HEADER_TITLE_CREATE_TEAM = 'Create team';
    public static readonly LABEL_TEAMS_HEADER_TITLE_TEAM_DETAILS = 'Team Details';

    public static readonly LABEL_TEAMS_PLACEHOLDER_TEAM_NAME = 'Team Name';
    public static readonly LABEL_TEAMS_PLACEHOLDER_ADMINISTRATOR = 'Administrator';
    public static readonly LABEL_TEAMS_PLACEHOLDER_FILTER = 'Filter';
    public static readonly LABEL_TEAMS_TITLE_USERS = 'Users';
    public static readonly LABEL_TEAMS_TITLE_TEAM = 'Team';
    public static readonly LABEL_TEAMS_UNABLE_TO_FETCH = 'Unable to fetch teams data.';
    public static readonly LABEL_TEAMS_NOT_AVAILABLE = 'Teams are not available';
    public static readonly LABEL_TEAMS_CONFIRM_DELETE = 'Delete the team';

    public static readonly LABEL_TEAMS_MEMBERS = 'Team members';

    public static readonly LABEL_11 = '';
    public static readonly LABEL_12 = '';
    public static readonly LABEL_13 = '';
    public static readonly LABEL_14 = '';
    public static readonly LABEL_15 = '';
    public static readonly LABEL_16 = '';

    // TEAMS Related END ....

    // PROJECTS Related ....
    public static readonly LABEL_PROJECTS_HEADER_TITLE = 'Projects';
    public static readonly LABEL_PROJECTS_HEADER_TITLE_CREATE = 'Create Project';
    public static readonly LABEL_PROJECTS_HEADER_TITLE_DETAILS = 'Project Details';

    public static readonly LABEL_PROJECTS_UNABLE_TO_FETCH = 'Unable to fetch projects data.';
    public static readonly LABEL_PROJECTS_NOT_AVAILABLE = 'Projects are not available';
    public static readonly LABEL_PROJECTS_PROJECT_NAME = 'Project Name';
    public static readonly LABEL_PROJECTS_CLIENT_NAME = 'Client Name';

    // PROJECTS Related END ....

    // ASSESSMENTS Related ....

    // ASSESSMENTS Related END ....

    // REPORTS Related ....

    // REPORTS Related END ....

    // WORKSHOP Related ....

    public static readonly LABEL_DROPDOWN_WORKSHOP_START = 'Start now';
    public static readonly LABEL_DROPDOWN_WORKSHOP_SCHEDULED = 'Schedule';

    public static readonly LABEL_BTN_WORKSHOP_IN_PROGRESS = 'Re-view/Print the final tree.';

    public static readonly LABEL_ALERT_TREE_ONE_SIBLING = 'Only one sibling node allowed.';

    // WORKSHOP Related END ....


    // GENERAL ....
    public static readonly LABEL_NO_DATA = 'No data available';
    public static readonly LABEL_BTN_TEXT_CANCEL = 'Cancel';
    public static readonly LABEL_BTN_TEXT_CREATE = 'Create';
    public static readonly LABEL_BTN_TEXT_UPDATE = 'Update';

    // POP-UP Dialogs TEXT ....
    public static readonly LABEL_COOL_DIALOG_OK_BUTTON = 'Yes';
    // POP-UP Dialogs TEXT END ....

    public static readonly LABEL_FETCHING = 'Fetching data ...';
    public static readonly LABEL_ERROR_TRY_AGAIN = 'An error occured, please try again.';

    public static readonly LABEL_PLACEHOLDER_START_DATE = 'Start Date';
    public static readonly LABEL_PLACEHOLDER_END_DATE = 'End Date';
    public static readonly LABEL_PLACEHOLDER_SELECT_TEAM = 'Select Team';
    public static readonly LABEL_INPUT_REQUIRED = 'Please enter a value';
    public static readonly LABEL_SELECT_REQUIRED = 'Please select a value';



    // GENERAL END ....

    // TOOLTIPS DATA ...
    public static readonly LABEL_TOOLTIP_EXPORT_PROJECTS = 'Export projects data';
    public static readonly LABEL_TOOLTIP_EDIT = 'Edit';
    public static readonly LABEL_TOOLTIP_DELETE = 'Delete';
    // TOOLTIPS DATA END ...

}
